import { render, staticRenderFns } from "./InvoicesPanel.vue?vue&type=template&id=6157a1c8"
import script from "./InvoicesPanel.vue?vue&type=script&lang=js"
export * from "./InvoicesPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports